<div class="scrollbar pg-sidebar" id="style-6">
  <div class="profile-img text-center">
    <img src="../../../../assets/images/logo/logo-unah-blanco.png" class="logoUnah">
  </div>

  <div class="pg-menu-wrap">

    <mat-accordion *ngFor="let menu of (sidebarService.Menus$ | async)" class="navList pg-group">
      <mat-expansion-panel class="pg-panel">
        <mat-expansion-panel-header class="pg-panel-header">

          <mat-panel-title>
            <span class="pg-group-icon"><i class="fa fa-th-large"></i></span>
            <span class="textSide pg-group-title">{{menu.texto}}</span>
          </mat-panel-title>

        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-nav-list appAccordion class="pg-nav-list">
            <mat-list-item appAccordionLink *ngFor="let menuitem of menu.hijos" [routerLinkActive]="['is-active']" class="fs pg-item">
              <div *ngIf="menuitem.mostrar" class="pg-item-inner">
                <a appAccordionToggle [routerLink]="menuitem.urlTemplate" class="pg-item-link">
                  <span class="pg-item-icon-chip"><i class="{{menuitem.icono}} icon"></i></span>

                  <span class="d-inline-block text-truncate textSide pg-item-label">{{ menuitem.texto }}</span>
                </a>
              </div>

            </mat-list-item>
          </mat-nav-list>
        </ng-template>

      </mat-expansion-panel>

    </mat-accordion>
  </div>

</div>
